<div class="calsoft-vertical-navigation-content">
	<calsoft-general [pageTitle]="PageTitle"></calsoft-general>
</div>